import { create } from 'zustand';

const useUserCountry = create((set) => ({
   country: '',
  setUserCountry: (userCountry) => set((state) => ({ ...state, country: userCountry })),
}));

export default useUserCountry;

